import React from 'react';
import ReactDOM from 'react-dom/client';
// Design system first: tokens, then the global baseline, then legacy styles so the
// redesign's own rules win while screens are still being migrated.
import './design/tokens.css';
import './design/global.css';
import './index.css';
import App from './App';
import store from "./redux/store";
import { Provider } from 'react-redux';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
